"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var createTeamMemberships = (0, _memoizeOne.default)(function (teamMemberships, orgRoles, organisationId) {
  return teamMemberships.map(function (teamMembership) {
    var _ref = teamMembership.user ? teamMembership.user : {},
        email = _ref.email,
        orgMemberships = _ref.orgMemberships;

    var orgMember = orgMemberships.find(function (_ref2) {
      var userEmail = _ref2.userEmail;
      return userEmail === email;
    });
    var isOrgAdminRoles = orgRoles.filter(function (_ref3) {
      var name = _ref3.name;
      return ['ADMIN', 'SHOOTSTA_ADMIN'].includes(name);
    });
    var isOrgEditorRole = orgRoles.filter(function (_ref4) {
      var name = _ref4.name;
      return ['SHOOTSTA_EDITOR'].includes(name);
    });
    return _objectSpread({
      organisationId: organisationId
    }, teamMembership, {
      status: orgMember.status,
      updatedAt: orgMember.updatedAt,
      isOrgAdmin: isOrgAdminRoles.map(function (role) {
        return role.roleId;
      }).includes(orgMember.roleId),
      isOrgEditor: isOrgEditorRole.map(function (role) {
        return role.roleId;
      }).includes(orgMember.roleId)
    });
  });
}, _lodash.default);
var _default = createTeamMemberships;
exports.default = _default;